<template>
  <div>
    <div>
      <!-- Home page content -->
      <main role="main">
        <div class="banner-btm">
          <div class="text-center py-5 container">
            <h1 class="text-center mb-3 title-color" v-html="$t('Home.BannerTitle')"></h1>
            <div class="col-md-6 mx-auto">
            <p class="home-paragraph mb-5" v-html="$t('Home.BannerDesc')"></p>
</div>
            <div class="readytosubmit mt-5">
              <h2 class="mb-2" v-html="$t('Home.ReadytoSubmitTitle')"></h2>
              <p class="main-body mb-4" v-html="$t('Home.ReadytoSubmitDesc')"></p>
              <div class="row d-flex justify-content-center">
                <div class="col-sm-12 text-center">
                  <router-link :to="{ name: 'Enter' }" class="btn btn-link mb-4 px-5 py-2"
                    data-gtm-elem="navigation-click" data-gtm-card-type="Learn More"
                    data-gtm-card-title="Ready to Upload?" data-gtm-link-text="Get Started">
                    {{ $t('Home.GetStartedBtn') }}
                  </router-link>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <span class="abbrev-terms" v-html="$t('Home.HavingTroubleLink')" @click="handleLinkClick"></span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="how-to-blk py-5" style="background-color: var(--mustard-yellow);">
          <div class="container">
            <h2 class="text-center mb-5">{{ $t('Home.HowToParticipateTitle') }}</h2>
            <div class="row text-center d-flex justify-content-center">
              <div class="col-md-4">
                <div class="home-card bg-transparent border-0 shadow-none">
                  <img :src="$t('Home.ShopImg')" :alt="$t('Home.ShopTitle')" class="img-fluid mb-3" />
                  <h4>{{ $t('Home.ShopTitle') }}</h4>
                  <p>
                    <small v-html="$t('Home.ShopDetail')"></small>
                  </p>
                </div>
              </div>

              <div class="col-md-4">
                <div class="home-card bg-transparent border-0 shadow-none">
                  <img :src="$t('Home.SnapImg')" :alt="$t('Home.SnapTitle')" class="img-fluid mb-3" />
                  <h4>{{ $t('Home.SnapTitle') }}</h4>
                  <p>
                    <small v-html="$t('Home.SnapDetail')"></small>
                  </p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="home-card bg-transparent border-0 shadow-none">
                  <img :src="$t('Home.SendImg')" :alt="$t('Home.SendTitle')" class="img-fluid mb-3" />
                  <h4>{{ $t('Home.SendTitle') }}</h4>
                  <p>
                    <small v-html="$t('Home.SendDetail')"></small>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>


      </main>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    startDate: {
      type: Date,
      required: true,
    },
    endDate: {
      type: Date,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    // New method: make <a> behave like router-links
    handleLinkClick(event) {
      const target = event.target.closest('a');
      if (target) {
        const href = target.getAttribute('href');

        // Only intercept internal links (those starting with '/')
        if (href && href.startsWith('/')) {
          event.preventDefault();
          const routeName = href.substring(1); // e.g. 'FAQ' from '/FAQ'

          if (routeName) {
            this.$router.push({ name: routeName }).catch(() => {
              // Fallback if route name doesn't exist
              this.$router.push(href);
            });
          }
        }
      }
    },
  }
};
</script>

<style scoped>
@media screen and (max-width: 575px) {}
</style>

<style scoped>
/* .home-card-bg {
  position: relative;
}
.home-card {
  box-shadow: 0 15px 25px rgba(129, 124, 124, 0.2);
  height: 380px;
  border-radius: 19px;
  backdrop-filter: blur(14px);
  background-color: rgb(255 255 255 / 20%);
  padding: 15px;
  text-align: left;
  line-height: 23px;
  font-size: 1.2rem;
}
.home-card-bg:before {
  content: '';
  position: absolute;
  height: 70px;
  width: 70px;
  top: -9px;
  left: 5px;
  background-color: #bf233a;
  border-radius: 18px;
}
.home-card img {
  height: 70px;
} */
/* .readytosubmit {
  background: #bf233a2b;
  border: 1px solid #bf233a;
  border-radius: 10px;
  padding: 20px 30px;
} */
@media screen and (max-width: 575px) {
  .home-card {
    height: auto;
    margin-bottom: 40px;
  }
}
</style>
